<script>
export default {
  /////////////////////////////////////////////////////
  // Data
  /////////////////////////////////////////////////////
  data() {
    return {
      actionsDropdownOpen: false,
      assignDropdownOpen: false,
      annotateToolOpen: false
    }
  },
  /////////////////////////////////////////////////////
  // Props
  /////////////////////////////////////////////////////
  props: {
    'step': {
      type: Number,
      default: 0
    },
    'dataLoaded': {
      type: Boolean,
      default: false
    }
  },
  watch: {
    step: function (val) {
      switch (val) {
        case 2:
          $('html, body').animate({ scrollTop: 0 }, 'slow');
          break
        case 3:
          $('html, body').animate({ scrollTop: 1600 }, 'slow');
          break
        case 4:
          $('html, body').animate({ scrollTop: 0 }, 'slow');
          break
        case 7:
          $('html, body').animate({ scrollTop: 0 }, 'slow');
          break
        case 8:
          $('html, body').animate({ scrollTop: 12200 }, 'slow');
          this.annotateToolOpen = false;
          break
        case 9:
          $('html, body').animate({ scrollTop: 7520 }, 'slow');
          this.annotateToolOpen = true;
          break
        case 10:
          $('html, body').animate({ scrollTop: 360 }, 'slow');
          this.annotateToolOpen = false;
          break
        case 11:
          $('html, body').animate({ scrollTop: 910 }, 'slow');
          break
        case 12:
          $('html, body').animate({ scrollTop: 910 }, 'slow');
          break
        case 13:
          $('html, body').animate({ scrollTop: 1610 }, 'slow');
          break
        case 14:
          $('html, body').animate({ scrollTop: 5170 }, 'slow');
          break
        case 15:
          $('html, body').animate({ scrollTop: 5870 }, 'slow');
          break
        case 16:
          $('html, body').animate({ scrollTop: 7980 }, 'slow');
          this.annotateToolOpen = false;
          break
        case 17:
          $('html, body').animate({ scrollTop: 8650 }, 'slow');
          this.annotateToolOpen = false;
          break
        case 18:
          $('html, body').animate({ scrollTop: 13600 }, 'slow');
          break
        case 19:
          $('html, body').animate({ scrollTop: 15720 }, 'slow');
          break
      }
    }
  },
  /////////////////////////////////////////////////////
  // Methods
  /////////////////////////////////////////////////////
  methods: {
    nextPage() {
      if (this.step == 19) {
        window.location = '11.html'
      }
    },
    prevPage() {
      if (this.step == 1) {
        window.location = '09.html'
      }
    },
    nextStep() {
      this.$emit('next', parseInt(this.step) + 1);
      if (this.step == 6) {
        this.actionsDropdownOpen = false;
      }
      if (this.step == 7) {
        this.assignDropdownOpen = false;
      }
    },
    prevStep() {
      this.$emit('prev', parseInt(this.step) - 1);
      if (this.step == 6) {
        this.actionsDropdownOpen = false;
      }
      if (this.step == 7) {
        this.assignDropdownOpen = false;
      }
    },
    toggleActionsDropdown() {
      this.actionsDropdownOpen = !this.actionsDropdownOpen;
    },
    toggleAssignDropdown() {
      this.assignDropdownOpen = !this.assignDropdownOpen;
    }
  }
}

</script>
